import { Skeleton, Stack } from '@mui/material';
import { PageContainer } from '@/components/shared/page-container';

export const PageSkeleton = () => {
  return (
    <PageContainer>
      <Stack spacing={1}>
        <Skeleton
          width="20%"
          height={24}
          data-testid="skeleton-loading-go-back"
        />
        <Skeleton
          width="50%"
          height={24}
          data-testid="skeleton-loading-title"
        />
        <Skeleton
          height={60}
          variant="rounded"
          data-testid="skeleton-loading-description"
        />
      </Stack>
    </PageContainer>
  );
};
